import { BigNumber, utils } from 'ethers'

export function normalizeToWei(value: BigNumber, decimals = 0) {
  if (decimals < 0) {
    throw Error(`Cannot normalize to wei with negative decimals (${decimals})`)
  }
  return utils.parseUnits(value.toString(), 18 - decimals)
}
